import { ElementType, PropsWithChildren } from "react";

import { listItemClasses, ListItemVariants } from "./List.style";

export type ListItemProps = {
  onClick?: () => void;
  className?: string;
  component?: ElementType;
} & ListItemVariants;

export function ListItem(props: PropsWithChildren<ListItemProps>) {
  const { onClick, component: Component = "li", className, ...rest } = props;

  return (
    <Component
      {...rest}
      className={listItemClasses({
        class: className,
      })}
      onClick={onClick}
    />
  );
}

export default ListItem;
